import React from 'react';

import { RouteObject } from 'react-router-dom';
import MainPage from 'pages/main/main/MainPage';
import MainOutlet from 'pages/main/MainOutlet';
import CandidateRegistrationPage from 'pages/main/candidateRegistration/CandidateRegistrationPage';
import ElectionOutlet from 'pages/main/elections/ElectionOutlet';
import ElectionPage from 'pages/main/elections/election/ElectionPage';
import ElectionsPage from 'pages/admin/elections/ElectionsPage';
import VotePage from 'pages/main/elections/vote/VotePage';
import AdminOutlet from 'pages/admin/AdminOutlet';
import LoginPage from 'pages/admin/login/LoginPage';
import AdminElectionPage from 'pages/admin/elections/election/AdminElectionPage';
import AdminElectionResultsPage from 'pages/admin/elections/results/AdminElectionResultsPage';

function RouteError(): React.ReactElement {
    return (
        <div style={{ padding: 24 }}>
            <h2>Что-то пошло не так</h2>
            <p>Перезагрузите страницу или вернитесь на главную.</p>
            <a href="/">На главную</a>
        </div>
    );
}

export const routes: RouteObject[] = [
    {
        element: <MainOutlet />,
        errorElement: <RouteError />,
        children: [
            {
                element: <MainPage />,
                index: true,
            },
            {
                element: <CandidateRegistrationPage />,
                path: 'candidates',
            },
            { element: <VotePage />, path: 'elections/:electionId/vote' },
            {
                element: <ElectionOutlet />,
                errorElement: <RouteError />,
                path: 'elections/:electionId',
                children: [
                    {
                        element: <ElectionPage />,
                        index: true,
                    },
                    {
                        element: <ElectionPage />,
                        path: 'candidates/:candidateId',
                    },
                ],
            },
        ],
    },
    {
        element: <AdminOutlet />,
        errorElement: <RouteError />,
        path: 'admin',
        children: [
            {
                element: <LoginPage />,
                path: 'login',
            },
            {
                element: <ElectionsPage />,
                index: true,
            },
            {
                element: <AdminElectionPage />,
                path: 'elections/:electionId',
            },
            {
                element: <AdminElectionResultsPage />,
                path: 'elections/:electionId/results',
            },
        ],
    },
];

export default routes;
